package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.runtime.Composable

@Composable
actual fun KeepScreenOn(enabled: Boolean) {
    // No-op on web: display sleep is browser-managed; the Wake Lock API requires a secure
    // context + user activation and silently no-ops in most embedded contexts anyway.
}
